
import get from 'lodash.get'
import { setPageTitle } from '@/utils/dom'
import { getGuideAndOtherConfig } from '@/api/chat'
import { recordBrowseTracks, recordBrowseVisit, recordLanding } from '@/api/browse_tracks'
// import { SHOW_COMPANY_LOGO_OR_NAME } from '@/constants/message'
import {
    TIME_TO_INSERT_WELCOME,
    SHOW_BEFORE_DIALOG
} from '@/constants/pub_sub'

import {
    getRequest
} from '@/utils'
import request from '@/utils/request'
const COMPANY_UID_MAP = 'company_uid_map'
/**
 *
 */
function getCompanyUidMap () {
    let companyUidMap = {}

    try {
        /**
         * localStorage.getItem() 无 key 时，return null
         * JSON.parse(null) return null
         */
        companyUidMap = JSON.parse(localStorage.getItem(COMPANY_UID_MAP))
            || {}
    } catch {
        companyUidMap = {}
    }

    return companyUidMap
}
function saveCompanyUidMap ({
    companyCode,
    companyUidMap,
    uid
}) {
    try {
        companyUidMap[companyCode] = uid
        localStorage.setItem(COMPANY_UID_MAP, JSON.stringify(companyUidMap))
    } catch (err) {
        // eslint-disable-next-line
        console.error(err)
    }
}

export default {
    data () {
        return {
            showCompanyLogoOrName: '',
            isSupportHuman: 'robot',
            hasLoadSetting: false,
            hasAppendMessageSocketConnection: false,
            ableShowWelcome: false,
            sidebar:{},
            sessionModel: '', //会话模式
            welcomeText: '', // 欢迎语
            welcomeGuideText: '', // 常见问题引导
            welcomeMode: '', // 常见问题卡片模式
            welcomeSwiperListMessageData: {}, // 与 [card(mode)] 消息类型的消息体一致
            chatMode: {
                display_common: false,  // 是否展示常见问题
                activate_task: true,  // 是否成功激活套电   
                task_msg: {} 
            }
        }
    },
    methods: {
        async setGuideAndOtherConfig () {
            try {
                const {
                    webpage_style: webpageStyle,
                    robot,
                    robot_guide: guide,
                    is_current_service_none: ableShowWelcome,
                    welcome,
                    webpage_entrance,
                    enable_skill_group,
                    pre_inquiry_form,
                    hot_recomment,
                    qa_component
                } = await getGuideAndOtherConfig(this.entryKey, this.uid)

                this.hasLoadSetting = true

                const {
                    label_name: pageTitle,
                    user_img: backupUserAvatar
                } = webpageStyle
                
                this.getTaskStatus()
                this.sessionModel = robot.enable_service
                this.ableShowWelcome = ableShowWelcome
                this.$store.commit('setCurrentService', ableShowWelcome)
                this.welcomeText = welcome || ''
                this.welcomeGuideText = get(guide, 'guide_text') || ''
                this.welcomeMode = get(guide, 'mode') || ''
                this.welcomeSwiperListMessageData = guide || {}
                this.sidebar = qa_component.sidebar
                this.$store.commit('setTheme', webpage_entrance)
                this.$store.commit('setSkillGroup', {
                    key: 'enable',
                    value: enable_skill_group
                })

                //机器人是否点赞点踩存储
                this.$store.commit('setRobotEnable', robot.robot_replace_evaluation_enable)
                this.setHotWords(hot_recomment)
                this.detectSupportHuman(robot)
                this.setHeaderLogo(webpageStyle)
                this.setRobot(robot)
                this.setBackupUserAvatar(backupUserAvatar)
                
                //判断用户首次进入
                let company_uid_map = localStorage.getItem('company_uid_map')
                if (company_uid_map) {
                    if (JSON.parse(company_uid_map)[this.$eventBus.companyCode]) {
                        console.log('不是首次进入')
                        if (this.hasAppendMessageSocketConnection) {
                            this.insertRobotWelcome()
                        }
                    } else {
                        if (pre_inquiry_form.enable) {
                            this.$eventBus.$emit(SHOW_BEFORE_DIALOG, pre_inquiry_form)
                            this.$eventBus.$on('insertRobotWelcome', () => {
                                this.insertRobotWelcome()
                            })
                        } else {
                            this.insertRobotWelcome()
                        }
                    }
                } else {
                    if (pre_inquiry_form.enable) {
                        this.$eventBus.$emit(SHOW_BEFORE_DIALOG, pre_inquiry_form)
                        this.$eventBus.$on('insertRobotWelcome', () => {
                            this.insertRobotWelcome()
                        })
                    } else {
                        this.insertRobotWelcome()
                    }
                }
                
                let companyUidMap = getCompanyUidMap(this.$eventBus.companyCode)
                saveCompanyUidMap({
                    companyCode: this.$eventBus.companyCode,
                    companyUidMap,
                    uid: this.uid
                })
                // if (this.hasAppendMessageSocketConnection) {
                //     this.insertRobotWelcome()
                // }
                setPageTitle(pageTitle)
            } catch (err) {
                // eslint-disable-next-line
                console.error(err)
            }
        },
        // 获取日常模式和套电模式的状态，套电优先
        getTaskStatus () {
            request({
                url: 'guide/task_guide',
                method: 'get',
                params: {
                    chat_user_id: this.uid,
                    e:getRequest().e,
                    url: window.location.href
                }
            }).then(data => {
                this.chatMode = data

                // 套电接口返回后，再调浏览轨迹相关的接口
                if (this.parentDomainConfig.domain) {
                    recordLanding({
                        chat_user_id: this.uid,
                        e: this.entryKey,
                        landing_page: this.parentDomainConfig.url,
                        location_href: this.parentDomainConfig.referrer
                    })
                    recordBrowseVisit({
                        chat_user_id: this.uid,
                        domain: this.parentDomainConfig.domain
                    })
                    recordBrowseTracks({
                        name: this.parentDomainConfig.name,
                        url: this.parentDomainConfig.url,
                        chat_user_id: this.uid,
                        entry_id: this.entryKey
                    }).then(({ unique_id }) => {
                        this.unique_id = unique_id

                        // 首次开启会话
                        if (this.chatMode.activate_task) {
                            this.sendFirstChat()
                        }
                    })
                }
            })
        },
        detectSupportHuman ({ enable_service: isSupportHuman }) {
            this.isSupportHuman = isSupportHuman
            this.$store.commit('setData', { key: 'isSupportHuman', value: isSupportHuman })
        },
        setHotWords (hotWords) {
            this.$eventBus.setHotWords(hotWords)
        },
        setBackupUserAvatar (avatar) {
            this.$eventBus.setBackupUserAvatar(avatar)
        },
        setRobot (robot) {
            this.$eventBus.setRobot(robot)
        },
        setHeaderLogo ({
            show_way: showWay,
            company_logo: companyLogo,
            company_name: originCompanyName,
            global_display: globalDisplay
        }) {
            /**
             * header 的 Logo 位置
             * 根据 webpage_style 的 show_way 判断显示 Logo 还是 name
             * 优先取webpage_style，若字段为空则取 company 字段
             * 若 show_way 为 logo，但 logo 的链接为空，则最终显示 name
             */
            const result = {}
            result.globalDisplay = globalDisplay
            // const {
            //     LOGO,
            //     NAME
            // } = SHOW_COMPANY_LOGO_OR_NAME
            if (showWay == 'logo') {
                result.logo = companyLogo

                if (!companyLogo) {
                    result.name = originCompanyName
                }

            } else if (showWay == 'name') {
                result.name = originCompanyName
            }

            this.$eventBus.setCompany(result)
            this.showCompanyLogoOrName = showWay
        },
        /**
         * 欢迎语（text、card[mode]）插在 socket 消息后
         * 欢迎语 和 常见问题 如果都存在则都要推送
         */
        insertRobotWelcome () {
            if (!this.ableShowWelcome) {
                return
            }
            // 若无文本，仅卡片，则 卡片 需要 forceInsertTime
            let isNoText = false
            let guideTime = 0
            if (this.welcomeText.enable) { // 欢迎语
                this.$eventBus.$emit('showinputstatus', {is_input:true})
                this.appendWelcomeText(this.welcomeText.text, 'welcome')
                this.welcomeText.text.forEach((val) => {
                    guideTime = guideTime + val.duration
                })
            }
            
            setTimeout(() => {
                if (this.chatMode.activate_task) {
                    this.$eventBus.$emit('showinputstatus', {is_input:true})
                    this.appendTask(this.chatMode.task_msg)
                }
                if (this.sessionModel != 'human') {
                    if (this.chatMode.display_common) {
                        if (this.welcomeGuideText) { // 常见问题引导语
                            this.$eventBus.$emit('showinputstatus', {is_input:true})
                            this.appendWelcomeText(this.welcomeGuideText, 'welcomeGuide', guideTime)
                        }
            
                        if (!this.welcomeText.text && !this.welcomeGuideText) {
                            isNoText = true
                        }
                    
                        if (this.welcomeMode) {
                            // 判断 data（即 swiperList）是否为空数组
                            if ((get(this.welcomeSwiperListMessageData, 'data') || []).length > 0) {
                                this.$eventBus.$emit('showinputstatus', {is_input:true})
                                this.appendWelcomeSwiperList(this.welcomeMode, this.welcomeSwiperListMessageData, isNoText, guideTime)
                            }
                        }
                    }
                }
            }, 3000)
        }
    },
    created () {
        this.$eventBus.$on(TIME_TO_INSERT_WELCOME, () => {
            this.hasAppendMessageSocketConnection = true
            // if (this.hasLoadSetting) {
            //     console.log(111)
            //     this.insertRobotWelcome()
            // }
        })
    },
    beforeDestroy () {
        this.$eventBus.$off(TIME_TO_INSERT_WELCOME)
    }
}
